import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addNotificationUnsubscriberRecord({ commit }, item) {
    return this.$axios.$post('admin/notificationUnsubscriberRecords/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeNotificationUnsubscriberRecord({ commit }, item) {
    return this.$axios.$delete(`admin/notificationUnsubscriberRecords/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateNotificationUnsubscriberRecord({ commit }, item) {
    return this.$axios.$put(`admin/notificationUnsubscriberRecords/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchNotificationUnsubscriberRecords({ commit }) {
    return this.$axios.$get('admin/notificationUnsubscriberRecords').then((response) => {
      commit('load', response.data)
    })
  },
}
